import { Button, DrawerFooter, VStack } from "@chakra-ui/react";
import { useState } from "react";
import { Drawer, Input } from "../../common";
import { useMutation } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import {
  fetchLeadSourceById,
  updateLeadSource,
} from "../../../utils/api/global-config.api";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

type data = {
  id: number;
  isOpen: boolean;
  onClose: any;
  refetchParent: any;
};
interface ApiResult {
  data: any;
}
interface ApiRequest {
  lead_source: {
    name: string;
  };
}
const EditLeadSource = (props: data) => {
  const { id: dealerId } = useParams();
  const { isOpen, onClose, refetchParent, id } = props;
  const toast = useToast();
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const mutation = useMutation<ApiResult, Error, ApiRequest, unknown>({
    mutationFn: async (payload) => {
      try {
        const response = await updateLeadSource(id, payload, dealerId);
        return { data: response.data };
      } catch (error) {
        throw error;
      }
    },
    onSuccess: () => {
      refetchParent();
      onClose();
      toast({
        description: "Lead Source created successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
    },
    onError: (error: any) => {
      toast({
        description: `Error creating lead source: ${
          error?.response?.data?.errors?.toString() ?? "Something went wrong"
        }`,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top",
      });
    },
  });

  const handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (!name?.trim()) {
      setNameError("Name cannot be empty");
      return;
    }

    setNameError("");

    const requestData: ApiRequest = {
      lead_source: {
        name: name,
      },
    };

    mutation.mutate(requestData);
  };

  const { data, isLoading } = useQuery({
    queryKey: ["fetchLeadSource"],
    queryFn: () => fetchLeadSourceById(id, dealerId),
    refetchOnWindowFocus: false,
    retry: false,
    onSuccess: (data) => {
      setName(data?.name);
    },
  });

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Lead Source"
      isLoading={isLoading || mutation?.isLoading}
    >
      <VStack alignItems="flex-start" padding="1rem 1.5rem" w="100%" gap="1rem">
        <Input
          placeholder="Write Lead Source"
          label="Enter Lead Source"
          onChange={(e: any) => setName(e.target.value)}
          value={name}
          isRequired={true}
          error={nameError}
        />
      </VStack>
      <DrawerFooter
        position="absolute"
        bottom="0"
        left="0"
        width="100%"
        borderTop="1px solid var(--grey-300)"
        display="flex"
        alignItems="center"
        gap="0.81rem"
      >
        <Button variant="outline" w="100%" size="xl" onClick={onClose}>
          Cancel
        </Button>
        <Button w="100%" size="xl" onClick={handleSubmit}>
          Confirm
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditLeadSource;
